import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-14">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-ghost-line text-2xl text-accent-500"></i>
              </div>
              <span className="font-heading text-xl font-bold">九妖漫画</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              免费在线看漫画全集，高清无删减资源，让您一站式阅读所有漫画。每日更新，追更不等待。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">漫画分类</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">关于我们</Link>
              <a href="#" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">帮助中心</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">联系我们</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-sm text-foreground-300"></i>
                </div>
                <span className="text-sm text-foreground-300">contact@jiuyaomanhua.com</span>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-sm text-foreground-300"></i>
                </div>
                <span className="text-sm text-foreground-300">400-888-9999</span>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-sm text-foreground-300"></i>
                </div>
                <span className="text-sm text-foreground-300">北京市朝阳区建国路88号</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-700/30 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 九妖漫画网 JiuYaoManHua.com 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 transition-colors" aria-label="QQ">
              <i className="ri-qq-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}